export default "__VITE_ASSET__DYOzMuqF__"